import clsx from "clsx";
import Rand from "rand-seed";

export const AvatarPlaceholder: React.FC<{
  seed: string;
  children: string;
}> = ({ seed, children }) => {
  const rng = new Rand(seed);
  const num = rng.next() * 4;
  return (
    <div
      className={clsx(
        "flex grow bg-gradient-to-br @container",
        num > 3
          ? "from-pink-500 to-yellow-200"
          : num > 2
            ? "from-yellow-500 to-red-200"
            : num > 1
              ? "from-green-500 to-blue-200"
              : "from-blue-500 to-green-200",
      )}
    >
      <div className="m-auto text-[50cqw] title">{children}</div>
    </div>
  );
};
